
import { ClassDatum } from './Interfaces';
interface AnswerColor {
    dark: string;
    light: string;
}
class Utils {
    public attentionColor: {[key: string]: string[]};
    public answerColor: {
        groundtruth: AnswerColor;
        correct: AnswerColor;
        incorrect: AnswerColor;
    };
    constructor() {
        this.attentionColor = {
            entity: ['#fee9d4'],//['#fff6ed', '#fee9d4', '#feddbb', '#fcc389', '#fcb770'],
            others: ['#eef4fa' , '#dae8f5', '#c6dbef', '#9ec2e4', '#9ec2e4']//'#c6dbef', '#9ecae1', '#6baed6']
        };
        this.answerColor = {
            groundtruth: {dark: 'black', light: '#d9d9d9'},
            correct: {dark: '#31a354', light: '#a1d99b'}, // green
            incorrect: {dark: '#d6616b', light: '#e7969c'}, // red
        }
    }
    /**
     * Generate class for everything.
     * @param viewType      <String>    tree|network|item
     * @param elementType   <String>    node|group|text|link|keyword|cluster
     * @param identifier    <String>    info to identify one single item
     */
    public genClass (viewType: string, elementType: string,
                     identifier: string|number|(string|number)[]): ClassDatum {
        let keystring: string = '';
        switch (typeof(identifier)) {
            case 'string': keystring = <string>identifier; break;
            case 'number': keystring = (<number>identifier).toString(); break;
            default:
                const identifierArr = (<(number|string)[]>identifier).map((i) => {
                    return typeof(i) === 'string' ? i : i.toString();
                });
                keystring = identifierArr.join('-');
        }
        const element = `${viewType}-${elementType}`;
        const key = `${element}-${keystring}`;
        return {
            view: viewType,
            element: element,
            key: key,
            total: `${viewType} ${elementType} ${element} ${key}`
        };
    };

    /**
     * Filter and find unique instances in an array
     * Only used to be put in the filter.
     */
    public uniques(value: any, index: any, self: any[]): boolean {
        return self.indexOf(value) === index;
    }

    public uniqueArr(arr: any[]): any[] {
        const u = {};
        const a = [];
        for(let i = 0, l = arr.length; i < l; ++i){
            if(!u.hasOwnProperty(arr[i])) {
                a.push(arr[i]);
                u[arr[i]] = 1;
            }
        }
        return a;
    }

    // group array into hash list by a key
    public groupBy<T> (xs: T[], key: string): {[key: string]: T[]} {
        return xs.reduce((rv, x) => {
            (rv[x[key]] = rv[x[key]] || []).push(x);
            return rv;
        // tslint:disable-next-line:align
        }, { });
    };

    /**
     * Return all permutations of 'length' elements from array:
     * This is a generator function
     * @param array <any[]> just a given array
     * @param length <number> the number the elements in the returned permutations.
     */
    public* permute(array: any[], length: number): any {
        if (length < 1) {
            yield [];
        } else {
            for (const element of array) {
                for (const combination of this.permute(array, length - 1)) {
                    yield combination.concat(element);
                }
            }
        }
    }

    /**
     * Generate all bit combinations for a given number [[true, true, true], ...]
     * Mostly used to generate which model is included when building error intersections.
     * @param count <int> the number of bits needed.
     */
    public genBits(count: number): boolean[][] {
        // tslint:disable-next-line:no-bitwise
        const bool2d: boolean[][] = [];
        // tslint:disable-next-line:no-bitwise
        for (let i = 0; i < (1 << count); i++) {
            const boolArr: boolean[] = [];
            //Increasing or decreasing depending on which direction
            //you want your array to represent the binary number
            for (let j = count - 1; j >= 0; j--) {
                // tslint:disable-next-line:no-bitwise
                boolArr.push(Boolean(i & (1 << j)));
            }
            bool2d.push(boolArr);
        }
        return bool2d;
    }
    
    public argMax(array: number[]) {
        return array.map((x, i) => [x, i]).reduce((r, a) => (a[0] > r[0] ? a : r))[1];
    }

    public argSort(array: number[]) {
        const idxes = array.map((x, i) => i);

        return idxes.sort((a, b) => array[b] - array[a]);
    }
    
    public genStrId (key: string|number): string {
        if (typeof key === 'string') {
            return key.replace(/[^a-zA-Z1-9]/g, '-');
        } else {
            return 'number';
        }
    }

    public transpose (a: any[]): any[] {
        return a && a.length && a[0].map && a[0].map((_: any, c: any) => a.map(r => r[c]) || []);
    }
}

export const utils = new Utils();


// WEBPACK FOOTER //
// ./src/stores/Utils.ts